import React from 'react'
import './SignUp.css';
import Logo from './img/logo/TC-LOGO.png';
import { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import axios from 'axios';
import { useRef } from 'react';
import { useEffect } from 'react';

function SignUp() {
    
    const [fname, setFname] = useState('');
    const [lname, setLname] = useState('');
    const [address, setAddress] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [counter, setCounter] = useState(0);
    const history = useHistory();

    function useInterval(callback, delay) {

        const savedCallback = useRef();
      
        // Remember the latest callback.
        useEffect(() => {
          savedCallback.current = callback;
        }, [callback]);
      
        // Set up the interval.
        useEffect(() => {
          let id = setInterval(() => {
            savedCallback.current();
          }, delay);
          return () => clearInterval(id);
        }, [delay]);

        
    }

    useInterval(() => {
        setCounter(counter + 1);
    }, 1000);

    useEffect(() => {
        if(counter === 5){
            document.getElementById("777").style.display = "none";
            document.getElementById("787").style.display = "none";
            document.getElementById("593").style.display = "none";
            document.getElementById("247").style.display = "none";
            document.getElementById("307").style.display = "none";
            document.getElementById("707").style.display = "none";
            document.getElementById("4242").style.display = "none";
        }
    }, [counter])

    function isValidEmail(email) {
        return /\S+@\S+\.\S+/.test(email);
    }

    const onSubmit = () => {
        if(fname === ''){
            document.getElementById("777").style.display = "block";
            document.getElementById("__777").style.border = "1px solid red";
            setCounter(0);
        }else if(lname === ''){
            document.getElementById("787").style.display = "block";
            document.getElementById("__787").style.border = "1px solid red";
            setCounter(0);
        }else if(address === ''){
            document.getElementById("593").style.display = "block";
            document.getElementById("__593").style.border = "1px solid red";
            setCounter(0);
        }else if(phone === ''){
            document.getElementById("247").style.display = "block";
            document.getElementById("__247").style.border = "1px solid red";
            setCounter(0);
        } else if(!isValidEmail(email)){
            document.getElementById("307").style.display = "block";
            document.getElementById("__307").style.border = "1px solid red";
            setCounter(0);
        }else if(password === ''){
            document.getElementById("707").style.display = "block";
            document.getElementById("__707").style.border = "1px solid red";
            setCounter(0);
        }else if(password !== confirmPassword){
            document.getElementById("4242").style.display = "block";
            document.getElementById("__707").style.border = "1px solid red";
            document.getElementById("__4242").style.border = "1px solid red";
            setCounter(0);
        }
        else{
            
            axios
                .get('https://toycityzimbabwe.com/backend/postClientDetails.php',{params: {fname, lname, address, phone, email, password}} )
                .then(res => {
                console.log(res.data)
                })
                .catch( error => {
                    console.log(error)
                });
            
            history.push('/signin');
        }
    }

    return (
        <div className='signup'>
            <div className='signup_logo'>
                <Link to='/'>
                    <img className='logo' src={Logo}/>
                </Link>
            </div>
            <div className='signup_text'>
                <h2>Sign Up</h2>
                <h3>Create your Toy City Account</h3>
            </div>
            <div className='signup__blueSide'>
            </div>
            <div className='signup__center'>
                <input type="text" id='__777' value={fname} onChange={e => setFname(e.target.value)} placeholder="First Name"></input>
                <div className='signup__error' id='777'><label id='424'>First name required</label></div>
                <input type="text" id='__787' value={lname} onChange={e => setLname(e.target.value)} placeholder="Last Name"></input>
                <div className='signup__error' id='787'><label id='424'>Last name required</label></div>
                <input type="text" id='__593' value={address} onChange={e => setAddress(e.target.value)} placeholder="Address"></input>
                <div className='signup__error' id='593'><label id='424'>Address required</label></div>
                <input type="text" id='__247' value={phone} onChange={e => setPhone(e.target.value)} placeholder="Phone Number"></input>
                <div className='signup__error' id='247'><label id='424'>Phone number required</label></div>
                <input type="email" id='__307' value={email} onChange={e => setEmail(e.target.value)} placeholder="Email"></input>
                <div className='signup__error' id='307'><label id='424'>Email invalid</label></div>
                <input type="password" id='__707' value={password} onChange={e => setPassword(e.target.value)} placeholder="Password"></input>
                <div className='signup__error' id='707'><label id='424'>Password required</label></div>
                <input type="password" id='__4242' value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} placeholder="Confirm Password"></input>
                <div className='signup__error' id='4242'><label id='424'>The passwords do not much!</label></div>
                <div className='signup__error' id='42423'>
                    <label id='424'>pass!</label>
                </div>
                
                <button onClick={onSubmit}>Sign Up</button>
                <div><p>Go back to</p><Link to="/signin"><p className='signup_goto'>&nbsp;Sign In</p></Link></div>
            </div>
        </div>
    )
}

export default SignUp;